import React, { Component } from 'react';
import SurveyRect from './Shared/SurveyRect';
import FormatText from '../Utils/TextFormatter';
import Button from './Shared/Button';
import md5 from 'md5';

export default class QuestionPage extends Component {

    state = {
        qKey:"",
        answer:"",
        isValid: false,
    }

    componentDidMount(){
        this.setState({qKey:this.props.qKey, isValid: this.props.minCharacters === 0});
    }


    render(){
        const {style, question, placeHolder, qTextSize, inputType, altButtonTitle} = this.props;
        const padding = 28;

        const buttonText = (altButtonTitle !== "" && altButtonTitle !== undefined) ? altButtonTitle : "המשך";

        let questionText;
        if(qTextSize === `small`){ 
            questionText = <div className="smallQuestion">{FormatText(global.isMale,question)}</div>
        }
        if(qTextSize === `medium`){ 
            questionText = <h3>{FormatText(global.isMale,question)}</h3>
        }
        if(qTextSize === `large`){ 
            questionText = <h2>{FormatText(global.isMale,question)}</h2>
        }

        let inputField;
        if(inputType === `text`){
            inputField = <textarea maxLength={2000} placeholder={FormatText(global.isMale,placeHolder)} 
                onChange={(e) => {this.setState({answer: e.target.value}, _=>this.validateAnswer()); }}
                style={{
                    position:"absolute",
                    right:0,
                    width: 268,
                    height: 128,
                    bottom: 100,
                    paddingRight: 8,
                    borderRadius: 4,
                    border: `1px solid ${global.colorTheme.main}`,
                    resize: "none"
            }}/>
        }
        if(inputType === `number`){
            inputField = <input className="sekerApp" type="number" placeholder={FormatText(global.isMale,placeHolder)} 
                onChange={(e) => {this.setState({answer: e.target.value}, _=>this.validateAnswer()); }}
                style={{
                    position:"absolute",
                    right:0,
                    width: 268,
                    height: 48,
                    bottom: 200,
                    paddingRight: 8,
                    border: 'none',
                    borderBottom: `2px solid ${global.colorTheme.main}`,
                    fontSize: 18,
            }}/>
        }
        if(inputType === `email`){
            inputField = <input className="sekerApp" type="email" placeholder={FormatText(global.isMale,placeHolder)} 
            onChange={(e) => {this.setState({answer: e.target.value}, _=>this.validateAnswer()); }}
            style={{
                position:"absolute",
                direction: "ltr",
                right:0,
                width: 268,
                height: 48,
                bottom: 200,
                paddingRight: 8,
                border: 'none',
                borderBottom: `2px solid ${global.colorTheme.main}`,
                fontSize: 18,
        }}/>
        }

        return <div style={style}>
            <SurveyRect {...this.props} H={440}>
                <div  style={{
                    position: "absolute",
                    right: padding,
                    left: padding,
                    top: padding,
                    bottom: 0,
                    overflow: "scrollY",
                    textAlign: "right",
                }}>
        
                    {questionText}
                    <div className="separation-bar"/>
                    {inputField}
                    <Button style={{
                        position:"absolute",
                        left:0,
                        bottom:padding,
                    }} text={buttonText} isActive={this.state.isValid} onClick={() => {
                        // validate & save
                        this.SetAnswer();                       
                    }}/>
                </div>
            </SurveyRect>
        </div>
    }

    validateAnswer(){

        let inputIsValid = ( this.state.answer.length >= this.props.minCharacters );

        const regexString = this.props.regexValidation;
        if( inputIsValid && regexString) {
            const regex = new RegExp( regexString );
            // console.log( regex );
            inputIsValid = regex.test( String( this.state.answer ) );
            // console.log( "is valid? " + inputIsValid );
        }
        this.setState({isValid: inputIsValid});

    }

    SetAnswer()
    {
        let ans = this.state.answer;
        if(this.props.scrambleAnswer){
            ans = md5(ans.replace(/\s+/g, ''));
        }

        global.setAnswer(this.state.qKey, ans);
        global.nextStage(this.props.followingScreen);
    }
}



// WEBPACK FOOTER //
// ./src/Comp/OpenQuestionPage.js